export default "__VITE_ASSET__aad6380e__"